import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
import { EnvironmentConfig } from '@evento-ng/libs';

if (environment.production) {
  enableProdMode();
}

EnvironmentConfig.init({
  apiRoot: environment.apiRoot,
  authRoot: environment.authRoot,
  title: environment.title,
});

platformBrowserDynamic()
  .bootstrapModule(AppModule)
  .catch((err) => console.error(err));
